import { createVariantEvent, track } from "@/analytics/events/base"

export const createVariantUsedEvent = ({
  flag,
  value,
}: {
  flag: string
  value: string | boolean
}) => {
  track(createVariantEvent(flag, value))
}
